import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchRolesAPI } from "./rolesAPI";
import { showModal } from "../statusModal/statusModal";

const initialState = {
  list: [],
  status: "idle",
  error: null,
};

export const fetchRoles = createAsyncThunk(
  "roles/fetchRoles",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const data = await fetchRolesAPI();
      dispatch(
        showModal({
          message: "تم جلب بيانات الوظائف بنجاح",
          status: "success",
        })
      );
      return data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch roles"
      );
    }
  }
);

const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload.data;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.error;
      });
  },
});

export default rolesSlice.reducer;
